module.exports = __webpack_public_path__ + "static/media/haiwaifengongsirenyuanguanli1.c576b381.png";